import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { ChatRoom } from './pages/ChatRoom';
import { ExploreResources } from './pages/ExploreResources';
import { CreateChat } from './pages/CreateChat';
import { Login } from './pages/Login';      // NEW IMPORT
import { Signup } from './pages/Signup';    // NEW IMPORT
import { Header } from './components/Header'; 
import { AIAssistantWidget } from './components/AIAssistantWidget';
import { FAQ as FAQPage } from './components/FAQ'; // Import FAQ as a page/section

function App() {
  return (
    <BrowserRouter>
        <Header /> 
        
        <Routes>
            {/* Core Application Routes */}
            <Route path="/" element={<Home />} />
            <Route path="/community" element={<ChatRoom />} />
            <Route path="/resources" element={<ExploreResources />} /> 
            
            {/* Utility Routes */}
            <Route path="/create-chat" element={<CreateChat />} /> 
            <Route path="/faq" element={<FAQPage />} /> // Route the FAQ component
            
            {/* Authentication Routes (NEW) */}
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />

            {/* Default/404 Route */}
            <Route path="*" element={<Home />} />
        </Routes>
        
        <AIAssistantWidget />

    </BrowserRouter>
  );
}

export default App;